import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { MgService } from 'src/app/services/mg.service';

@Component({
  selector: 'app-list-business-responsive',
  templateUrl: './list-business-responsive.component.html',
  styleUrls: ['./list-business-responsive.component.scss']
})
export class ListBusinessResponsiveComponent implements OnInit {

  @Input() items: any;
  
  constructor(
    private api: MgService,
    private router: Router,
  ) { }

  ngOnInit(): void {
  }

  public get apiService() {
    return this.api;
  }

  public goToAddBusiness(): void {
    this.router.navigate(['/operador/empresas/adicionar'])
  };

  public listBusinessUsers(business: number){
    this.router.navigateByUrl(`/operador/usuarios/empresa/${business}`)
  }

  public listBusinessCalls(business: number){
    this.router.navigateByUrl(`/operador/chamados?businesses=${business}`)
  }
}
